import React from 'react'
import { useNavigate } from 'react-router-dom'
import Cookies from 'js-cookie'
import {
  CDropdown,
  CDropdownDivider,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
  CImage,
} from '@coreui/react-pro'
import { cilAccountLogout } from '@coreui/icons'
import CIcon from '@coreui/icons-react'
import AvatarUserIcon from '../../assets/icons/AvatarUserIcon.png'

// helpers
import Axios from '../../helpers/axios'
import { getFullName, getEmailUser } from '../../helpers/text-format'

const AppHeaderDropdown = () => {
  const navigate = useNavigate()
  const token = Cookies.get("ut");
  const user = JSON.parse(localStorage.getItem("user"))
  const handleLogout = () => {
    Axios({
      method: 'post',
      url: '/api/sso/v1/users/logout'
    })
      .then(() => {
        if (token) {
          document.cookie = `ut=${token}; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
        }
        Cookies.remove('ut', { path: '/', secure: true });
        localStorage.removeItem("user")
        localStorage.removeItem("general_setting")
        navigate('/login')
      })
      .catch((err) => {
        console.error(err)
      })
  }

  return (
    <CDropdown variant="nav-item">
      <CDropdownToggle placement="bottom-end" className="py-0" caret={false}>
        {getEmailUser(user)}
        <CImage fluid src={AvatarUserIcon} className="mx-3" />
        {getFullName(user?.profile ? user?.profile : user?.username)}
      </CDropdownToggle>
      <CDropdownMenu className="pt-2" placement="bottom-end">
        <CDropdownItem onClick={() => navigate('/my-profile')}>
          My Profile
        </CDropdownItem>
        <CDropdownDivider />
        <CDropdownItem onClick={() => handleLogout()} >
          <CIcon icon={cilAccountLogout} className="me-2" />
          Log Out
        </CDropdownItem>
      </CDropdownMenu>
    </CDropdown>
  )
}

export default AppHeaderDropdown
